export const config = {
    NOMBRE_EMPRESA: process.env.REACT_APP_NOMBRE_EMPRESA,
    VERSION: process.env.REACT_APP_VERSION,
    ENTORNO: process.env.REACT_APP_ENTORNO,
    DOCS_DE_CUANTOS_DIAS_ANTES: process.env.REACT_APP_DOCS_DE_CUANTOS_DIAS_ANTES || '15',
    CANT_DOCS_PER_PAGE: process.env.REACT_APP_CANT_DOCS_PER_PAGE || '15'
};